import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import useTranslateText from '../use_translate_text';
import './toast.scss';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Toast = (props) => {

  const { show, handleClose } = props,
        { translateText } = useTranslateText(),
        { vertical, horizontal } = show;

  return <Snackbar anchorOrigin={{ vertical, horizontal }} open={show.open} onClose={handleClose}
    className="toast-main" disableWindowBlurListener={true}>
    <Alert onClose={handleClose} severity="info" sx={{ width: '100%' }}>
      <div style={{ display: 'flex' }}>
        <span>{translateText('Please Wait')}</span>
        <div className="dot-flashing ml-4 mt-1"></div>
      </div>
    </Alert>
  </Snackbar>;
};

export default Toast;